import { useSuspenseQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth } from "react-oidc-context";

import { type CatalogFilters, type Record, catalog } from "@/catalog.ts";
import { useLocale } from "@/locales";

export function useCatalogItems(filters?: CatalogFilters) {
  const { locale } = useLocale();

  const auth = useAuth();
  const { data } = useSuspenseQuery(
    catalog.items(
      "lantmateriet",
      {
        ...(filters ?? {
          type: ["http://www.opengis.net/def/rel/ogc/1.0/dataset"],
        }),
        limit: 100,
      },
      { language: locale, token: auth.user?.access_token },
    ),
  );
  return {
    data,
    forUri: useCallback(
      (uri: string): Record | undefined =>
        data.features.find((record) =>
          record.links.some(
            (link) => link.rel === "self" && link.href.endsWith(uri),
          ),
        ),
      [data],
    ),
    uriFor: useCallback((item: Record): string => {
      const link = item.links.find((l) => l.rel === "self");
      if (!link) {
        throw new Error("Could not find self link for item");
      }
      return new URL(link.href).pathname;
    }, []),
  };
}
